import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTimes } from '@fortawesome/pro-light-svg-icons'

import { useSetState } from '@domain-group/react-hooks'

import {
  Box, Button, ListItem, Text,
} from '@domain-group/suit-theme'

const togglePermissions = (action, stateKey, toggleTemplatePermissions, setState) => {
  setState({ [stateKey]: true })
  toggleTemplatePermissions(action).then(() => {
    setState({ [stateKey]: false })
  })
}

const defaultState = {
  loadingAssign: false,
  loadingUnassign: false,
}

const ServiceListItem = (props) => {
  const { callbacks, title } = props
  const { toggleTemplatePermissions } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { loadingAssign, loadingUnassign } = state

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        lineHeight: '1.3',
        marginBottom: 'medium',
        paddingBottom: 'medium',
      }}
      disableHover
    >
      <Box alignItems="center" justifyContent="space-between">
        <Text fontSize="small" variant="ellipsis">{title}</Text>

        <Box justifyContent="flex-end" width="auto">
          <Button
            buttonStyle="secondaryCreate"
            icon={<FontAwesomeIcon icon={faPlus} />}
            iconPosition="right"
            loading={loadingAssign}
            marginRight="small"
            minWidth="80px"
            onClick={() => togglePermissions('assign', 'loadingAssign', toggleTemplatePermissions, setState)}
            size="small"
            width="auto"
          >
            Assign
          </Button>

          <Button
            buttonStyle="secondaryDestroy"
            icon={<FontAwesomeIcon icon={faTimes} />}
            iconPosition="right"
            loading={loadingUnassign}
            minWidth="90px"
            onClick={() => togglePermissions('unassign', 'loadingUnassign', toggleTemplatePermissions, setState)}
            size="small"
            width="auto"
          >
            Unassign
          </Button>
        </Box>
      </Box>
    </ListItem>
  )
}

ServiceListItem.propTypes = {
  callbacks: PropTypes.shape({
    toggleTemplatePermissions: PropTypes.func.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
}

export default ServiceListItem
